import React from 'react';

import { FileBox, View } from 'src/components/basic';

import { remCss, scssVariables, useScreenDetail } from 'src/helpers';
import { MediaGroup } from 'src/components/complex';
import { getFileBoxType, isFileUnavailable } from 'components/basic/FileBox/utils';
import SVGIcon from 'components/svg';

const Video = ({ item, mediaRerender }) => {
  const screen = useScreenDetail();
  const style = {
    maxWidth: remCss(Math.min(screen.innerWidth * 0.65, 340)),
    minHeight: remCss(200)
  };
  let haveFiles = item.files && item.files.length > 0;
  return (
    <FileBox
      template={2}
      file={haveFiles ? item.files[0] : item.media[0]}
      remoteFile={item.media[0]}
      mediaRerender={mediaRerender}
      list={haveFiles ? item.files : item.media}
      remoteList={item.media}
      onClose={null}
      showFileName={false}
      showFileSize={false}
      styles={style}
      enableEvent={true}
    />
  );
};

const Files = ({ item, mediaRerender }) => {
  const files = item.files?.length > 0 ? item.files : item.media;

  const screen = useScreenDetail();
  let haveDicom = files && files.length > 0 && files.find((m) => m.isDicom);

  return (
    <div
      className={'mc-flex-20-col'}
      style={{
        maxWidth: Math.min(screen.innerWidth * 0.65, haveDicom ? 387 : 350),
        width: remCss(350)
      }}
    >
      {files.map((f, index) => (
        <FileBox
          template={2}
          list={files}
          key={'mc-media-' + index}
          file={files[index]}
          onClose={null}
          styles={{ width: remCss(50), height: remCss(50) }}
          onlyPreview={true}
          showFileName={true}
          showFileSize={true}
          mediaRerender={mediaRerender}
          isMultiple={files?.length > 1}
          wide={true}
          fileIndex={index}
          enableEvent={true}
          videoProps={{
            playIcon: (
              <View style={{ position: 'absolute' }}>
                <SVGIcon
                  iconname={'play-icon'}
                  width={40}
                  fill={scssVariables['colors-mc-white']}
                />
              </View>
            )
          }}
        />
      ))}
    </div>
  );
};

const Images = ({ item, imageGroupProps }) => {
  let haveFiles = item.files && item.files.length > 0;
  const files = haveFiles
    ? item.files.filter((f) => f.file?.uploadState?.status !== 'aborted')
    : item.media;
  const screen = useScreenDetail();
  const hasFirstViewTimer = item.data?.selfDestruct?.type === 'first_view';
  // max uploaded is 10
  const exFiles = haveFiles || hasFirstViewTimer ? files.length / 5 : 0;

  const allExpired = !item.media.some((m) => !isFileUnavailable(m));
  if (allExpired) {
    return (
      <FileBox
        template={2}
        onClose={null}
        file={files[0]}
        styles={{ width: remCss(50), height: remCss(50) }}
        onlyPreview={true}
        showFileName={true}
        showFileSize={true}
        isMultiple={files?.length > 1}
        wide={true}
        enableEvent={true}
      />
    );
  }
  return (
    <div
      className={'mc-flex-col'}
      style={{ width: Math.min(screen.innerWidth * 0.65, remCss(400)) }}
    >
      <MediaGroup
        images={haveFiles || hasFirstViewTimer ? files.slice(0, 5) : item.media}
        remoteImages={item.media}
        template={files.length === 1 ? 1 : 2}
        length={4}
        enableEvent={true}
        maxImgHeight={item.media[0]?.width > item.media[0]?.height ? null : 450}
        {...imageGroupProps}
      />
      {exFiles > 1 && (
        <MediaGroup
          images={files.slice(5, 10)}
          remoteImages={item.media}
          template={files.length === 1 ? 1 : 2}
          length={4}
          enableEvent={true}
          maxImgHeight={450}
          {...imageGroupProps}
        />
      )}
    </div>
  );
};

export default class MediaFiles extends React.PureComponent {
  render() {
    const { item, mediaRerender, imageGroupProps } = this.props;

    let mediaContent = null;
    if (item.media?.length > 0) {
      let mediaType = item.media?.find((f) => getFileBoxType(f.file || f) !== 'image')
        ? 'file'
        : 'photo';
      mediaType =
        mediaType === 'file' && item.media.length === 1 && item.media[0].fileType !== 'other'
          ? item.media[0].fileType
          : mediaType;

      switch (mediaType) {
        case 'photo':
          mediaContent = (
            <Images item={item} imageGroupProps={imageGroupProps} mediaRerender={mediaRerender} />
          );
          break;
        case 'audio':
          mediaContent = (
            <FileBox
              template={2}
              file={item.media[0]}
              remoteFile={item.media[0]}
              onClose={null}
              styles={{ width: remCss(50), height: remCss(50) }}
              onlyPreview={false}
              mediaRerender={mediaRerender}
              enableEvent={true}
            />
          );
          break;
        case 'video':
          mediaContent = <Video item={item} mediaRerender={mediaRerender} />;
          break;
        default:
          mediaContent = <Files item={item} mediaRerender={mediaRerender} />;
          break;
      }
    }
    return mediaContent;
  }
}
